import React from 'react'
import NoticeTable from './components/NoticeTable'
import useNoticeList from './hooks/useNoticeList'
import AppPagination from '../../../components/AppPagination'

export default function NoticeListScreen() {
  const { state, actions } = useNoticeList()

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Header ── */}
      <section className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Cloud &amp; Communication
          </p>
          <div className="flex items-center gap-3 mt-1">
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
              List of Notices
            </h1>
            <span className="rounded-xl bg-surface-container-high px-3 py-1 text-xs font-bold text-on-surface-variant">
              {state.totalCount} entries
            </span>
          </div>
        </div>
      </section>

      {/* ── Table & Pagination Wrapper ── */}
      <div className="flex flex-col gap-4">
        <NoticeTable
          records={state.pagedRecords}
          loading={state.loading}
          onDelete={actions.handleDelete}
        />

        {state.totalCount > 0 && (
          <div className="flex flex-col gap-3 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest px-6 py-4 sm:flex-row sm:items-center sm:justify-between shadow-xs">
            <span className="text-xs font-medium text-on-surface-variant">
              Showing {state.rangeStart} to {state.rangeEnd} of {state.totalCount} entries
            </span>

            <AppPagination
              page={state.page}
              totalPages={state.totalPages}
              onPageChange={actions.setPage}
              onPrevious={actions.goToPreviousPage}
              onNext={actions.goToNextPage}
              canPrevious={state.page > 1}
              canNext={state.page < state.totalPages}
            />
          </div>
        )}
      </div>
    </div>
  )
}
